import { lazy, Suspense } from 'react';
import { Navigate, redirect, RouteObject } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import { PortfolioRouteEnum } from '~/router/@types';
import { getUserInfoQuery } from '~/apis/auth';

const CounterfeitAssetsPage = lazy(() => import('~/pages/Portfolio/Assets/_counterfeit'));
const PiracyAssetsPage = lazy(() => import('~/pages/Portfolio/Assets/_piracy'));

const IpPortfolioPage = lazy(() => import('~/pages/Portfolio/IPDocuments'));
const IpPortfolioDocumentPage = lazy(() => import('~/pages/Portfolio/IPDocuments/DocumentPage'));

const InfringingImagesPage = lazy(() => import('~/pages/Portfolio/InfringingImages'));
const AuthorizedSeller = lazy(() => import('~/pages/Portfolio/AuthorizedSeller'));
const Models = lazy(() => import('~/pages/Portfolio/Models'));

const CopyrightedImagesPage = lazy(() => import('~/pages/Portfolio/CopyrightedImages'));
const CopyrightedImagesBrandPage = lazy(() => import('~/pages/Portfolio/CopyrightedImages/BrandList'));
const CopyrightedImagesCollectionPage = lazy(() => import('~/pages/Portfolio/CopyrightedImages/CollectionList'));
const CopyrightedImagesImagePage = lazy(() => import('~/pages/Portfolio/CopyrightedImages/ImageList'));

export const PORTFOLIO_ROUTES: RouteObject[] = [
  {
    path: PortfolioRouteEnum.IpDocuments,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingCircularProgress open />}>
            <IpPortfolioPage />
          </Suspense>
        ),
      },
      {
        path: ':id',
        element: (
          <Suspense fallback={<LoadingCircularProgress open />}>
            <IpPortfolioDocumentPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: PortfolioRouteEnum.InfringingImages,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <InfringingImagesPage />
      </Suspense>
    ),
  },
  {
    path: PortfolioRouteEnum.Assets,
    children: [
      {
        index: true,
        loader: async () => {
          const userData = await getUserInfoQuery();

          if (userData?.use_piracy) {
            return redirect('piracy');
          } else {
            return null;
          }
        },
        element: <Navigate to="counterfeit" replace />,
      },
      {
        path: 'counterfeit',
        element: (
          <Suspense fallback={<LoadingCircularProgress open />}>
            <CounterfeitAssetsPage />
          </Suspense>
        ),
      },
      {
        path: 'piracy',
        element: (
          <Suspense fallback={<LoadingCircularProgress open />}>
            <PiracyAssetsPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: PortfolioRouteEnum.CopyrightedImages,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <CopyrightedImagesPage />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingCircularProgress open />}>
            <CopyrightedImagesBrandPage />
          </Suspense>
        ),
      },
      {
        path: ':brand_id',
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingCircularProgress open />}>
                <CopyrightedImagesCollectionPage />
              </Suspense>
            ),
          },
          {
            path: ':collection_id',
            element: (
              <Suspense fallback={<LoadingCircularProgress open />}>
                <CopyrightedImagesImagePage />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: PortfolioRouteEnum.AuthorizedList,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <AuthorizedSeller />
      </Suspense>
    ),
  },
  {
    path: PortfolioRouteEnum.Models,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <Models />
      </Suspense>
    ),
  },
];
